import React, { useEffect, useState } from 'react';
import { overlayRegistry } from './OverlayRegistry';

/**
 * OverlayContainer - Renders all registered overlay plugins
 *
 * Place this inside the video container to render custom overlays
 * from features that have registered with the OverlayRegistry.
 */
const OverlayContainer = () => {
  const [overlays, setOverlays] = useState([]);

  useEffect(() => {
    // Get initial overlays
    setOverlays(overlayRegistry.getOverlays());

    // Subscribe to changes
    const unsubscribe = overlayRegistry.subscribe((newOverlays) => {
      setOverlays(newOverlays);
    });

    return unsubscribe;
  }, []);

  if (overlays.length === 0) {
    return null;
  }

  return (
    <>
      {overlays.map(({ id, component: Component }) => (
        <Component key={id} />
      ))}
    </>
  );
};

export default OverlayContainer;
